/**
 * Compress a single image if it exceeds the size threshold.
 * Images smaller than 500KB are returned as-is.
 */
const compressSingleImage = (file) => {
  if (file.size < 500000) return Promise.resolve(file);

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 600;
        const scale = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.imageSmoothingEnabled = false;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            resolve(new File([blob], file.name, { type: "image/jpeg" }));
          },
          "image/jpeg",
          0.4,
        );
      };
    };
  });
};

/**
 * Compress multiple images in parallel.
 * Only large images (>=500KB) get compressed, smaller ones pass through instantly.
 * Returns array of { ...originalImageObj, file: compressedFile }
 */
export const compressImagesParallel = async (images) => {
  const promises = images.map(async (img) => {
    if (!img.file) return img;
    const compressed = await compressSingleImage(img.file);
    return { ...img, file: compressed };
  });

  return Promise.all(promises);
};
